import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '@core/services/loader.service';
import { ConfigPresorteo } from '../../../models/config-pesorteo.model';
import { ConfigPresorteoService } from '../../../services/configPresorteo/config-presorteo.service';

@Component({
  selector: 'app-page-config-presorteo-edit',
  templateUrl: './page-config-presorteo-edit.component.html',
  styleUrls: ['./page-config-presorteo-edit.component.scss']
})
export class PageConfigPresorteoEditComponent implements OnInit {

  configPresorteo: ConfigPresorteo;
  type: string = 'edit';
  constructor(
    private router: Router,
    private aRouter: ActivatedRoute,
    private loadService: LoaderService,
    private configPresorteoService: ConfigPresorteoService
  ) { }

  ngOnInit(): void {
    this.aRouter.params.subscribe(params => {
      if (params.id) {
          this.getConfigPresorteo(params.id);
      }
    });
  }

  getConfigPresorteo(id: number): void {
    this.loadService.show();
    this.configPresorteoService.getConfigPresorteo(id)
    .then(response => {
      if (response.success) {

        this.configPresorteo = response.data;
      }
    })
    .finally(() => {
      this.loadService.hide();
    });
  }

  goBack() {
    this.router.navigate(['/presorteo/megaloto/config-presorteo']);
  }

}
